import { useState } from "react";
import { Link } from "react-router-dom";
import { Mountain, Layers } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { Footer } from "@/components/BusinessSection";
import { MapboxMap } from "@/components/MapboxMap";

export default function MapPreview() {
  const [terrain, setTerrain] = useState(true);
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="bg-paper min-h-screen text-charcoal flex flex-col" data-testid="map-preview-page">
      <SiteHeader />
      <main className="flex-1 max-w-[1200px] w-full mx-auto px-5 sm:px-8 py-8">
        <div className="flex items-end justify-between gap-4 flex-wrap mb-4">
          <div>
            <div className="flex items-center gap-2 text-forest">
              <Mountain size={18} className="text-blaze" />
              <h1 className="font-serif text-3xl sm:text-4xl tracking-tight">Map preview</h1>
            </div>
            <p className="text-sm text-charcoal/55 mt-1">
              Mapbox foundation check — the terrain-analysis feature builds on this component. Token loaded from environment, outdoors basemap.
            </p>
          </div>
          <button
            onClick={() => { setTerrain(!terrain); setLoaded(false); }}
            className={`inline-flex items-center gap-2 text-sm font-semibold px-4 py-2 border transition-colors ${terrain ? "bg-forest text-bone border-forest" : "bg-white text-charcoal/70 border-saddle/25 hover:border-forest/40"}`}
            data-testid="map-terrain-toggle"
          >
            <Layers size={15} /> 3D terrain {terrain ? "on" : "off"}
          </button>
          <Link to="/terrain-analysis" className="inline-flex items-center gap-2 text-sm font-semibold px-4 py-2 bg-blaze text-white hover:brightness-95" data-testid="open-terrain-analysis">
            <Mountain size={15} /> Open terrain analysis
          </Link>
        </div>
        <div className="border border-saddle/25 bg-white p-1.5">
          <MapboxMap
            center={[-106.82, 39.19]}
            zoom={11.5}
            pitch={terrain ? 62 : 0}
            enableTerrain={terrain}
            height={560}
            onLoad={() => setLoaded(true)}
          />
        </div>
        <p className="text-[11px] text-charcoal/45 mt-2" data-testid="map-load-status">
          {loaded ? "Map loaded · terrain source: Mapbox Terrain DEM v1 (visual relief; elevation sampling ships with the terrain feature)" : "Loading map tiles…"}
        </p>
      </main>
      <Footer />
    </div>
  );
}
